export default __webpack_public_path__ + "static/layout_cloud_topLeft-67e469335ec1ab7b655bb5f9ab8d2695.png";